import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-950 px-4 pb-28 pt-12 text-center sm:pb-16" data-id="element-173" data-mp="19j53j40hsmi0">
      <div className="mx-auto max-w-2xl" data-id="element-174" data-mp="206rfd7jc9ao0">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold-400" data-id="element-175" data-mp="209x3okk588io">
          Observación estratégica
        </p>
        <p className="mt-4 font-display text-xl font-bold text-white" data-id="element-176" data-mp="2a5h1jci9pha2">🦷 Dra. Karito</p>
        <p className="mt-1 text-[12.5px] font-medium uppercase tracking-[0.16em] text-white/50" data-id="element-177" data-mp="1mfmq8zdlk0rx">
          Sistema de Diagnóstico Facial
        </p>

        <nav aria-label="Enlaces legales" className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-[12.5px] text-white/60" data-id="element-178" data-mp="1hiw7u5ebkt3c">
          <a href="#" className="transition-colors hover:text-gold-300" data-id="element-179" data-mp="1reh5jrccv77a">
            Términos y Condiciones
          </a>
          <span aria-hidden="true" data-id="element-180" data-mp="13ntxn62fwhkq">·</span>
          <a href="#" className="transition-colors hover:text-gold-300" data-id="element-181" data-mp="yr3gefewffxq">
            Política de Privacidad
          </a>
          <span aria-hidden="true" data-id="element-182" data-mp="1eh0zj7o19azl">·</span>
          <a href="#" className="transition-colors hover:text-gold-300" data-id="element-183" data-mp="1efzm4wjjocep">
            Contacto
          </a>
        </nav>

        <p className="mt-6 text-[11.5px] leading-relaxed text-white/40" data-id="element-184" data-mp="1nanr0ll7js2z">
          © 2026 Dra. Karito — Todos los derechos reservados. Este material es de carácter educativo
          y de apoyo clínico; la decisión final siempre corresponde al profesional tratante.
        </p>
      </div>
    </footer>;
}